import React from 'react';

function Celebration() {
  return (
    <svg
      width={260}
      height={260}
      viewBox="0 0 153 161"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="76.5152"
        cy="84.1274"
        r="55.9237"
        fill="#4ACCA9"
        stroke="#B4E9DA"
        strokeWidth="12"
      />
      <path
        d="M109.541 73.8862L97.8849 62.4541L70.687 89.1289L55.1454 73.8862L43.4892 85.3182L70.687 111.993L109.541 73.8862Z"
        fill="#E1F6F1"
      />
      <rect
        x="15.1232"
        y="0.499992"
        width="18.6461"
        height="18.6461"
        transform="rotate(45 15.1232 0.499992)"
        fill="#B4E9DA"
      />
      <rect
        x="9.17444"
        y="26.9153"
        width="12.4307"
        height="12.4307"
        transform="rotate(45 9.17444 26.9153)"
        fill="#B4E9DA"
      />
      <rect
        x="139.431"
        y="134.13"
        width="18.6461"
        height="18.6461"
        transform="rotate(45 139.431 134.13)"
        fill="#B4E9DA"
      />
    </svg>
  );
}

export default Celebration;
